export const connectorLocalStorageKey = 'CONNECTOR_ID'